import Vue from 'vue';
import VueResource from 'vue-resource';
import { mapMutations } from 'vuex';

import App from './App.vue';
import router from './router';
import Request from './utils/request';
import store from './store';

Vue.config.productionTip = false;
Vue.use(VueResource);

new Vue({
  store,
  data: {
    configError: null,
    configObj: null,
  },
  methods: {
    ...mapMutations('agenciesData', [
      'pushAgencyConfig',
    ]),
  },
  async mounted() {
    this.$router.options.base = window.location.origin;
    this.$http.get(`${window.location.origin}/index.json`).then((response) => {
      const config = response.body;
      Request.defaults.baseURL = config.backendURL;
      for (let index = 0; index < config.agencies.length; index += 1) {
        const agency = config.agencies[index];
        if (window.location.pathname === `/${agency.abbriviation}`) {
          this.pushAgencyConfig(agency);
        }
      }
      this.configObj = config;
    }, () => {
      console.log('Could Not Load Config!!');
      if (process.env.VUE_APP_CONFIG != null) {
        const config = (typeof process.env.VUE_APP_CONFIG === 'string') ? JSON.parse(process.env.VUE_APP_CONFIG) : process.env.VUE_APP_CONFIG;
        Request.defaults.baseURL = config.backendURL;
        for (let index = 0; index < config.agencies.length; index += 1) {
          const agency = config.agencies[index];
          if (window.location.pathname === `/${agency.abbriviation}`) {
            this.pushAgencyConfig(agency);
          }
        }
        this.configObj = config;
      } else {
        this.configError = 'No Valid Config Found!';
      }
    });
  },
  router,
  render: h => h(App),
}).$mount('#app');
